<script>
export default {
  render: function (h) {
    return (
      h('div', { class: 'notice-tips' }, this.$slots.default)
    )
  }
}
</script>

<style lang="less" scoped>
.notice-tips {
  background: #E7F7FF;
  border-radius: 2px;
  border: 1px solid #CAE9FF;
  padding: 4px 10px;
  color: #57AAFF;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  [class*=" open-icon-"], .icon-svg, .icon-svg-wrapper {
    margin-right: 3px;
    font-size: 14px;
    line-height: 14px;
    flex: 0 0 14px;
  }
  & > * {
    display: inline-flex;
    align-items: center;
    word-break: break-all;
  }
}
</style>
